import { PlatformCatalogListItemDTO, PlatformCatalogVersionListItemDTO, PublicationStatus } from "@bvhi/backend-api";
import { Chip, ChipProps, SxProps } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { compactStringDate, getDayJs } from "../../../../../../helpers/date";

interface Props {
  size?: "small" | "medium";
  sx?: SxProps;
  catalog: PlatformCatalogListItemDTO;
}

export function PlatformCatalogStatusChip({ size = "small", sx, catalog }: Props) {
  const { t } = useTranslation(["enums"]);

  let label = "";
  let color: ChipProps["color"] = "default";

  const catalogVersion: PlatformCatalogVersionListItemDTO | undefined = catalog.activeVersion;

  const catalogPublicationStatus = catalog.platformCatalogStatus;
  const catalogVersionPublicationStatus = catalogVersion?.platformCatalogVersionStatus;

  const versionPublishedFromDayJS = getDayJs(catalogVersion?.publishedFrom);
  const versionPublishedUntilDayJS = getDayJs(catalogVersion?.publishedUntil);
  const now = new Date();

  if (catalogPublicationStatus === PublicationStatus.DELETED) {
    label = t("enums:enums.platform.catalog.status.chip.deleted");
    color = "error";
  } else if (catalogPublicationStatus === PublicationStatus.PUBLISHED) {
    const isVersionPublished =
      catalogVersion !== null &&
      catalogVersion !== undefined &&
      (catalogVersionPublicationStatus ?? PublicationStatus.PUBLISHED) === PublicationStatus.PUBLISHED;

    const isInPublicationWindow =
      isVersionPublished &&
      versionPublishedFromDayJS &&
      (versionPublishedFromDayJS.isBefore(now) || versionPublishedFromDayJS.isSame(now)) &&
      (versionPublishedUntilDayJS === null ||
        versionPublishedUntilDayJS === undefined ||
        versionPublishedUntilDayJS.isAfter(now) ||
        versionPublishedUntilDayJS.isSame(now));

    if (isInPublicationWindow && versionPublishedFromDayJS) {
      if (versionPublishedFromDayJS && versionPublishedUntilDayJS) {
        label = t("enums:enums.platform.catalog.status.chip.liveFromUntil", {
          dateFrom: compactStringDate(versionPublishedFromDayJS),
          dateUntil: compactStringDate(versionPublishedUntilDayJS),
        });
        color = "success";
      } else if (versionPublishedFromDayJS) {
        label = t("enums:enums.platform.catalog.status.chip.liveSince", {
          dateFrom: compactStringDate(versionPublishedFromDayJS),
        });
        color = "success";
      } else {
        label = t("enums:enums.platform.catalog.status.chip.live");
        color = "success";
      }
    } else if (isVersionPublished && versionPublishedFromDayJS?.isAfter(now)) {
      if (versionPublishedUntilDayJS) {
        label = t("enums:enums.platform.catalog.status.chip.liveFromUntil", {
          dateFrom: compactStringDate(versionPublishedFromDayJS),
          dateUntil: compactStringDate(versionPublishedUntilDayJS),
        });
        color = "info";
      } else {
        label = t("enums:enums.platform.catalog.status.chip.liveFrom", {
          dateFrom: compactStringDate(versionPublishedFromDayJS),
        });
        color = "info";
      }
    } else if (isVersionPublished && versionPublishedUntilDayJS?.isBefore(now)) {
      label = t("enums:enums.platform.catalog.status.chip.expiredVersion");
      color = "warning";
    } else {
      label = t("enums:enums.platform.catalog.status.chip.draft");
      color = "warning";
    }
  } else {
    label = t("enums:enums.platform.catalog.status.chip.draft");
    color = "warning";
  }

  //   + Entwurf (Orange)
  // 	KatalogPublikationsstatus: Entwurf
  // 	oder KatalogVersion(en)Publikationsstatus: Entwurf oder keine Version im Datumsfenster
  // + Live ab 1.1.2025 (Blau)
  // 	KatalogPublikationsstatus: Bereit
  // 	und Eine Katalogversion bereit + Publikationdatum in der Zukunft

  // + Live seit 1.1.2024 (Grün)
  // 	Katalog Bereit
  // 	KV im Publikationsfenster

  //   "activeVersion": {
  //                 "id": "a14aa12d-bf31-4564-ac7c-10e7bf76fa56",
  //                 "name": "Published Katalog Version",
  //                 "platformCatalogVersionStatus": "PUBLISHED",
  //                 "version": "1.0.1",
  //                 "publishedFrom": "2024-09-03T20:00:00.000Z",
  //                 "publishedUntil": null
  //             }

  // switch (status) {
  //   case PublicationStatus.DELETED:
  //     label = t("enums:enums.user.status.deleted");
  //     color = "error";
  //     break;
  //   case PublicationStatus.DRAFT:
  //
  //     break;
  //   case PublicationStatus.PUBLISHED:
  //     label = t("enums:enums.platform.catalog.status.chip.published");
  //     color = "success";
  //     break;
  // }

  return <Chip color={color} label={label} size={size} sx={{ ...sx }} />;
}
